<template>
  <!-- Page Container -->
  <div v-if="feedInitialized" class="w3-container w3-content" style="max-width:1400px; margin-top:60px; padding-left: 0px; padding-right:0px">    
    <!-- The Grid -->
    <div class="w3-row">
      <div class="w3-col m1 w3-hide-small" style="width: 16px">&nbsp;</div>
      <!-- Left Column -->
      <div :class="'w3-col m' + (columns==4?'2':'3')">
        <!-- Profile -->
        <profile-section v-if="feedUser">
        </profile-section>
        <br>
        
        <!-- Search Form --> 
        <feed-select v-bind:feedType="feedType" />
        <div class="w3-hide-medium w3-hide-large">
          &nbsp;<toggle-button v-bind:isHidden="isSearchHidden" @show="showSearch()" @hide="hideSearch()" />
          <button @click="isSearchHidden?showSearch():hideSearch()" type="button" class="w3-button" style="margin:0px; padding:0px">
            <span style='font-weight:bold'>&nbsp;Filter:</span>
          </button> 
          <component v-if="!isSearchHidden" v-bind:is="searchComponent" />
        </div>
        <component class="w3-hide-small" v-bind:is="searchComponent" />
        <span class="w3-hide-small" style="color: #555555; font-size:12px">© 2018 Jybe</span>
        <span class="w3-hide-medium w3-hide-large" style="color: #555555; font-size:12px">&nbsp;</span>
        
        <!-- Accordion -->
        
        <!-- Interests --> 
        
        <!-- Alert Box -->
      
      <!-- End Left Column -->
      </div>

      <div class="w3-col m1 w3-hide-small" style="width: 16px">&nbsp;</div>

      <!-- Middle Column -->
      <div :class="'w3-col m' + (columns==4?'4':'8')">
        <component v-bind:is="feedComponent" />

      <!-- End Middle Column -->
      </div>
      
      <!-- Right Column -->
      <!-- <div :class="'w3-col m' + (columns==4?'6':'2')"> -->
        <!-- <component v-bind:is="formComponent" /> -->
        
      <!-- End Right Column -->
      <!-- </div> -->
      
    <!-- End Grid -->
    </div>
    
  <!-- End Page Container -->
  </div>
</template>

<script>
  import Feed from './Feed.ts'
  export default Feed
</script>
